import { renderCalcPos } from "../../helpers/helpers";
import { CalculationColumn } from "../../types/column-types";
import { Flex,Tooltip } from 'antd'
import { SendOutlined } from '@ant-design/icons'

export const createdShipmentPositionColumn: CalculationColumn = {
    dataIndex: 'createdShipmentPosition',
    title: '',
    fixed: 'right',
    width: 16,
    align: 'center',
    onCell: () => ({ colSpan: 1 }),
    render: renderCalcPos(r =>
        r.createdShipmentPosition ? (
            <Flex
            align="center"
            justify="center"
            style={{ width: '100%', height: '100%' }}
        >
            <Tooltip title="Позиция перенесена в отгрузку">
                <SendOutlined style={{ color: 'var(--ant-color-success)', fontSize: 16 }} />
            </Tooltip>
        </Flex>
        ) : null
    ),
}